<template>
  <v-col sm="4" cols="4">
    <v-card class="elevation-12" id="loginpage">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Login</v-toolbar-title>
        <div class="flex-grow-1"></div>
      </v-toolbar>
      <v-card-text>
        <div class="alert alert-danger" v-if="message">
          <p>{{ message }}</p>
        </div>
        <v-form>
          <v-text-field
            type="text"
            class="form-control"
            placeholder="Enter your username"
            v-model="user.username"
          />
          <v-text-field
            type="password"
            class="form-control"
            placeholder="Enter your password"
            v-model="user.password"
            @keyup.enter="handleLogin"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="primary"
          @click="handleLogin"
          :disabled="loading"
          :loading="loading"
        >
          Login
        </v-btn
        >
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "LoginForm",
  data() {
    return {
      loading: false,
      user: {
        username: "",
        password: ""
      },
      message: ''
    };
  },
  created() {
    if (this.loggedIn) {
      this.$router.push({ name: 'Home'});
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    handleLogin() {
      this.loading = true;
      if (this.user.username && this.user.password) {
        this.$store.dispatch('auth/login', this.user).then(
          () => {
            this.$router.push({ name: 'Home'});
          },
          error => {
            this.loading = false;
            this.message =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
        );
      }
    }
  }
};
</script>
